import React from "react";

function Service({ service: { name, content, icon } }) {
  return (
    <div className="service-item text-center">
      {typeof(icon) === "string" ? <i className={`${icon} icon-simple`}></i> : icon}
      <h4 className="my-3">{name}</h4>
      <p className="mb-0">{content}</p>
    </div>
  );
}

export default Service;
